
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFF",
                        "d": "M5.28 6.867c-1.717 0-3.108-1.386-3.108-3.096 0-1.71 1.391-3.095 3.108-3.095 1.716 0 3.107 1.386 3.107 3.095 0 1.71-1.391 3.096-3.108 3.096zm0-1.238c1.03 0 1.864-.832 1.864-1.858 0-1.025-.835-1.857-1.865-1.857s-1.864.832-1.864 1.857c0 1.026.835 1.858 1.865 1.858zm0 7.429c-2.746 0-4.972-.684-4.972-2.423 0-1.74 2.226-3.15 4.971-3.15 2.746 0 4.972 1.41 4.972 3.15s-2.226 2.423-4.972 2.423zm0-1.239c2.452 0 3.729-.55 3.729-1.184 0-.908-1.585-1.911-3.73-1.911-2.144 0-3.728 1.003-3.728 1.911 0 .634 1.276 1.184 3.728 1.184zm-1.365 3.235c-.198-.102-.326-.303-.334-.525-.009-.223.104-.432.294-.548.19-.116.427-.12.622-.012.982.527 2.08.802 3.195.8 3.739 0 6.77-3.03 6.77-6.769 0-3.223-2.27-5.982-5.387-6.628-.333-.07-.547-.395-.478-.728.07-.333.395-.546.728-.477C13.009.93 15.692 4.19 15.692 8c0 4.418-3.581 8-8 8-1.318.002-2.616-.323-3.777-.946zm8.47-5.56c-.103.323-.45.502-.773.4-.324-.104-.503-.45-.4-.774.114-.358.173-.735.173-1.12 0-1.346-.727-2.565-1.878-3.217-.289-.17-.388-.54-.223-.832.166-.292.534-.398.829-.239 1.547.873 2.503 2.512 2.502 4.288 0 .512-.078 1.014-.23 1.494z",
                        "transform": "translate(-1150 -738) translate(1029 724) translate(121 14)"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  